module.exports = __webpack_public_path__ + "img/0-70.17d38fe2.jpg";